import { call, put, takeLatest } from "redux-saga/effects";
import { ToastError, ToastSuccess } from "components/Global/Toasts/Toasty";
import { uploadFile } from "shared-utility/store/utils/fileHelper";
import { downloadXLSFile } from "utils/api";
import {
  defaultReturn
  , multipleObjectReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , handleCallback
} from "shared-utility/store/utils/helpers";

export const SREO_GET_COMPANIES = generateDefaultActions("SREO_GET_COMPANIES");
export const getCompanies = payload => makePayload(SREO_GET_COMPANIES.value, payload);

function* getCompaniesSaga() {
  const url = "/getCompanyForUser";
  yield requestSaga(SREO_GET_COMPANIES, url, "GET");
}

export const SREO_GET_SREO_PROPERTIES = generateDefaultActions("SREO_GET_SREO_PROPERTIES");
export const getSreoProperties = payload => makePayload(SREO_GET_SREO_PROPERTIES.value, payload);
function* getSreoPropertiesSaga(payload) {
  const url = `/sreo/properties?asOfDate=${payload.asOfDate}&sponsorCompanyId=${payload.sponsorCompanyId}`;
  yield requestSaga(SREO_GET_SREO_PROPERTIES, url, "GET");
}

export const SREO_GET_TEMPLATE = generateDefaultActions("SREO_GET_TEPMPLATE");
export const downloadUploadTemplate = payload => makePayload(SREO_GET_TEMPLATE.value, payload);
function* downloandUploadTeamplteSaga(payload) {
  const url = `/sreo/uploadtemplate?companyId=${payload.companyId}&asOfDate=${payload.asOfDate}`;
  yield call(downloadXLSFile, url, "GET", payload, "");
}

export const SREO_IMPORT = generateDefaultActions("SREO_IMPORT");
export const importSreoProperties = payload => makePayload(SREO_IMPORT.value, payload);
function* importSreoPropertiesSaga(payload) {
  const url = `/sreo/import?sponsorCompanyId=${payload.companyId}&asOfDate=${payload.asOfDate}`;
  payload.url = url;
  const response = yield call(uploadFile, payload);
  if (response.result.error) {
    yield put(SREO_IMPORT.createFailure({ error: response.result.reason }));
  } else {
    yield getSreoPropertiesSaga({ sponsorCompanyId: payload.companyId, asOfDate: payload.asOfDate });
    yield put(SREO_IMPORT.createSuccess({ error: "" }));
    payload.setUploadModalOpen(false);
  }
}

export const SREO_EXPORT_PROPERTIES = generateDefaultActions("SREO_EXPORT_PROPERTIES");
export const exportGrid = payload => makePayload(SREO_EXPORT_PROPERTIES.value, payload);
function* exportGridSaga(payload) {
  const url = "exportSREOGridResults";
  yield call(downloadXLSFile, url, "POST", payload, "");
}

// REDUCER
const initialState = {
  company: {},
  sreoProperties: [],
  importError: "",
  sponsorCompanies: []
};

export function sreoScreenerReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SREO_GET_COMPANIES.success:
      return multipleObjectReturn(state, ["sponsorCompanies", "company"], [payload.data, payload.userCompany]);

    case SREO_GET_SREO_PROPERTIES.success:
      return defaultReturn(state, payload.result, "sreoProperties");

    case SREO_IMPORT.success:
      ToastSuccess("SREO Property Upload Completed");

      return multipleObjectReturn(state, ["importError", "closeModal"], ["", true]);

    case SREO_IMPORT.failure:
      return defaultReturn(state, payload.error, "importError");

    case SREO_GET_TEMPLATE:
      return defaultReturn(state, payload.data, "sreoTemplate");

    case SREO_EXPORT_PROPERTIES.success:
      ToastSuccess("File Downloaded");

      return defaultReturn(state, "", "importError");

    default:
      return state;
  }
}

// SAGA
export function* sreoScreenerSaga() {
  yield takeLatest(SREO_GET_COMPANIES.value, getCompaniesSaga);
  yield takeLatest(SREO_GET_TEMPLATE.value, downloandUploadTeamplteSaga);
  yield takeLatest(SREO_IMPORT.value, importSreoPropertiesSaga);
  yield takeLatest(SREO_GET_SREO_PROPERTIES.value, getSreoPropertiesSaga);
  yield takeLatest(SREO_EXPORT_PROPERTIES.value, exportGridSaga);
}
